import { marked } from 'marked';

marked.setOptions({
  gfm: true,
  breaks: true,
});

const TABLE_STYLES = `
  .md-renderer-body {
    font-family: inherit;
    line-height: 1.95;
    color: #334155;
    text-align: justify;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .md-renderer-body h1 { font-size: 1.6em; margin: 1.2em 0 0.6em; font-weight: 700; color: #1e293b; }
  .md-renderer-body h2 { font-size: 1.35em; margin: 1.1em 0 0.5em; font-weight: 700; color: #1e293b; }
  .md-renderer-body h3 { font-size: 1.15em; margin: 1em 0 0.4em; font-weight: 700; color: #1e293b; }
  .md-renderer-body p { margin: 0.75em 0; }
  .md-renderer-body ul, .md-renderer-body ol { margin: 0.75em 0; padding-left: 2em; }
  .md-renderer-body li { margin: 0.3em 0; }
  .md-renderer-body blockquote {
    margin: 1em 0; padding: 0.5em 1em;
    border-left: 4px solid #1d4ed8;
    background: #f8fafc;
    color: #475569;
  }
  .md-renderer-body code {
    background: #f1f5f9; padding: 0.15em 0.4em;
    border-radius: 4px; font-size: 0.88em;
    font-family: 'Courier New', monospace;
    color: #b91c1c;
  }
  .md-renderer-body pre {
    background: #1e293b; color: #e2e8f0;
    padding: 1em; border-radius: 8px;
    overflow-x: auto; margin: 1em 0;
  }
  .md-renderer-body pre code {
    background: transparent; padding: 0;
    color: inherit; font-size: 0.88em;
  }
  .md-renderer-body hr {
    border: none; border-top: 2px solid #e2e8f0;
    margin: 1.5em 0;
  }
  .md-renderer-body a { color: #1d4ed8; text-decoration: underline; }
  .md-renderer-body img { max-width: 100%; height: auto; border-radius: 4px; margin: 1em 0; }
  .md-renderer-body table {
    border-collapse: collapse;
    width: 100%;
    margin: 1em 0;
    font-size: 0.95em;
    font-family: inherit;
    page-break-inside: auto;
  }
  .md-renderer-body table thead {
    display: table-header-group;
  }
  .md-renderer-body table thead tr {
    background-color: #1d4ed8;
    color: #ffffff;
    text-align: left;
  }
  .md-renderer-body table th,
  .md-renderer-body table td {
    padding: 10px 14px;
    border: 1px solid #d1d5db;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .md-renderer-body table th {
    font-weight: 700;
  }
  .md-renderer-body table tbody tr {
    border-bottom: 1px solid #dddddd;
  }
  .md-renderer-body table tbody tr:nth-of-type(even) {
    background-color: #f8fafc;
  }
  .md-renderer-body table tbody tr:last-of-type {
    border-bottom: 2px solid #1d4ed8;
  }
  .md-renderer-body table tbody tr:hover {
    background-color: #eef2ff;
  }
`;

export function renderMarkdown(content) {
  if (!content || !content.trim()) {
    return '<div class="md-renderer-body"><p style="color: #94a3b8; font-style: italic;">No records available.</p></div>';
  }
  try {
    const html = marked.parse(content);
    return `<div class="md-renderer-body">${html}</div>`;
  } catch (e) {
    console.error("Markdown render error:", e);
    return `<div class="md-renderer-body"><p>${content}</p></div>`;
  }
}

export function getMarkdownStyles() {
  return TABLE_STYLES;
}

export default renderMarkdown;
